import RfiChecklistCategoriesTable from './RfiChecklistCategoriesTable.component';

export default RfiChecklistCategoriesTable;
